import { Form, Formik } from "formik";
import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import * as Yup from "yup";
import "../../assets/css/aunjai-formincome.css";
import FormattedNumberInput from "../../components/form/FormattedNumberInput";
import BuildingIcon from "../../components/icons/BuildingIcon";
import OutlinedButton from "../../components/ui/OutlinedButton";
import PrimaryButton from "../../components/ui/PrimaryButton";
import HStack from "../../components/ui/Stack/HStack";
import { useIsDesktop } from "../../hooks/useIsDesktop";
import { useUser } from "../../hooks/useUser";
import { useLoanStore } from "../../stores/useLoanStore";
import Header from "../Header/HeaderComponent";
import HeaderDesktop from "../Header/HeaderDesktop";

const DEFAULT_FORM_INITIAL_VALUES = {
  monthly_income: "",
  out_time_income: "",
  other_income: "",
  is_mou: false,
};

const FormIncome = () => {
  const navigate = useNavigate();
  const { t } = useTranslation("formIncome");
  const { userData } = useUser();

  const isForeigner = userData?.is_foreigner;

  const setIncomeFormProfile = useLoanStore(
    (state) => state.setIncomeFormProfile
  );

  const goToListLoan = (values) => {
    navigate("/select-loan", { state: { formData: values } });
  };

  const validationSchema = Yup.object().shape({
    monthly_income: Yup.string().required(t("inputRevenue")),
    out_time_income: Yup.string(),
    other_income: Yup.string(),
  });

  const handleSubmitForm = (values) => {
    setIncomeFormProfile(values);
    goToListLoan(values); // Navigate with form data
  };
  const isDesktop = useIsDesktop();

  return (
    <div id="pageFormIncome">
      {isDesktop ? (
        <HeaderDesktop title={t("selectLoan")} showIcon={true} onBack={true} />
      ) : (
        <Header title={t("selectLoan")} showIcon={true} onBack={true} />
      )}

      <div className="wrapContent">
        <div id="pFormIncome">
          <div className="bFormIncome">
            <div className="bContent">
              <div className="bFirstContent">
                <div className="bTitle">
                  <h2>{t("loanForYou")}</h2>
                  <p>{t("revenueDetail")}</p>
                </div>
              </div>
              <div className="bSecondContent">
                <div>
                  <Formik
                    initialValues={DEFAULT_FORM_INITIAL_VALUES}
                    validationSchema={validationSchema}
                    onSubmit={(values) => {
                      handleSubmitForm(values); // Call handleSubmitForm
                    }}
                  >
                    {({ handleSubmit, errors, values, setFieldValue }) => (
                      <>
                        <Form className="bForm" onSubmit={handleSubmit}>
                          {/* รายได้ปัจจุบัน */}
                          <FormattedNumberInput
                            label={t("revenue")}
                            name="monthly_income"
                            placeholder={t("revenue2")}
                            errorMessage={errors.monthly_income}
                            required
                            value={values.monthly_income}
                            onChange={(value) => {
                              setFieldValue("monthly_income", value);
                            }}
                          />

                          {/* รายได้ล่วงเวลา (ไม่บังคับ) */}
                          <FormattedNumberInput
                            label={t("OT")}
                            name="out_time_income"
                            placeholder={t("OT2")}
                            errorMessage={errors.out_time_income}
                            value={values.out_time_income}
                            onChange={(value) => {
                              setFieldValue("out_time_income", value);
                            }}
                          />

                          {/* รายได้ส่วนอื่น (ไม่บังคับ) */}
                          <FormattedNumberInput
                            label={t("otherRevenue")}
                            name="other_income"
                            placeholder={t("otherRevenue2")}
                            errorMessage={errors.other_income}
                            value={values.other_income}
                            onChange={(value) => {
                              setFieldValue("other_income", value);
                            }}
                          />

                          <footer className="flex flex-col items-center gap-5">
                            <PrimaryButton type="submit">
                              {t("confirm")}
                            </PrimaryButton>
                            {userData && !isForeigner && (
                              <>
                                <HStack
                                  style={{
                                    marginTop: 10,
                                    marginBottom: 10,
                                  }}
                                  gap={2}
                                  fullWidth
                                >
                                  <div
                                    style={{
                                      width: "100%",
                                      height: 1,
                                      backgroundColor: "lightgray",
                                    }}
                                  />
                                  <p style={{ color: "lightgray" }}>
                                    {t("or")}
                                  </p>
                                  <div
                                    style={{
                                      width: "100%",
                                      height: 1,
                                      backgroundColor: "lightgray",
                                    }}
                                  />
                                </HStack>
                                <OutlinedButton
                                  onClick={(e) => {
                                    e.preventDefault();

                                    setIncomeFormProfile({
                                      ...values,
                                      is_mou: true,
                                    });
                                    navigate("/loan-process");
                                  }}
                                >
                                  <BuildingIcon />
                                  {t("mou")}
                                </OutlinedButton>

                                <p
                                  style={{
                                    color: "gray",
                                    fontSize: 12,
                                    textAlign: "center",
                                    marginTop: 10,
                                  }}
                                >
                                  {t("forMou")}
                                </p>
                              </>
                            )}
                          </footer>
                        </Form>
                      </>
                    )}
                  </Formik>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormIncome;
